export const getcompany = `
query {
  getCompany {
    success
    error
    message
    company {
      id
      companyName
      address1,
     address2,
      country
      pincode
      state
      city
      fiscalYear
      ownershipType
      incorporationDate
      gstNumber
      cinNumber
      ifscCode
      contactInfo{
      id
        salutation
        name
        designation
        phoneNumber
        email
      }
      logo
    }
  }
}
`